export default "__VITE_ASSET__BgqlxyNe__"